import { providersPropsMap } from '../../contexts/main/providersPropsMap';
import { initApi } from '../../services/initApi';
import { ScreenNames } from '../../contexts/BI/interfaces';
import {
  CreateControllerFn,
  ControllerParams,
} from 'yoshi-flow-editor-runtime';

const createController: CreateControllerFn = async ({
  flowAPI,
}: ControllerParams) => {
  const { setProps } = flowAPI.controllerConfig;
  const { isEditor } = flowAPI.environment;

  initApi(flowAPI);

  return {
    async pageReady() {
      try {
        const initialProps = {
          ...(await providersPropsMap({
            biSettings: {
              preventAutomaticallySendChallengeId: isEditor,
              screenName: ScreenNames.ThankYouPage,
              getItemsCount: () => 1,
            },
            flowAPI,
            enabledProviders: ['challengeDataProvider', 'inviteLinkProvider'],
          })),
        };

        setProps(initialProps);
      } catch (err) {
        console.error(err);
      }
    },
  };
};

export default createController;
